import { useLang } from 'hooks/lang';

import { Button, Card, Column, Row, Skeleton } from 'components/Blocks';
import { IconBox } from './IconBox';
import { ArrowRightIcon, ShoppingBagIcon } from 'components/Icons';

import { EntityLoader } from 'components/Entities';
import { NumCount } from './NumCount';

export function Packages(): JSX.Element {
  const { t } = useLang();

  return (
    <Column>
      <h6 className="text-xl font-semibold text-primary">{t('packages')}</h6>

      <EntityLoader
        target="invoice.availablePackages"
        loading={<Skeleton height={240} width={240} />}
      >
        {({ data }) => (
          <Column fullWidth={false} alignItems="center">
            <Card flow="column" className="h-[130px] w-[250px] self-start phone:w-full">
              <Row justifyContent="space-between">
                <span className="font-medium">{t('active-packages')}</span>

                <IconBox>
                  <ShoppingBagIcon />
                </IconBox>
              </Row>

              <NumCount count={data.length} />
            </Card>

            <Button to="packages" variant="ghost">
              <span className="text-sm font-medium">{t('active-packages')}</span>

              <ArrowRightIcon color="primary" />
            </Button>
          </Column>
        )}
      </EntityLoader>
    </Column>
  );
}
